import React, { ReactElement, FunctionComponent } from 'react'
import WebSwitch from 'react-switch'
import { RemoteControlledSwitchProps } from './RemoteControlledSwitchProps'

const RemoteControlledSwitch: FunctionComponent<RemoteControlledSwitchProps> = ({
    value,
    onColor,
    offColor,
    onSwitchPress,
    testID,
}): ReactElement => (
    <WebSwitch
        onChange={onSwitchPress}
        checked={value}
        onColor={onColor}
        offColor={offColor}
        checkedIcon={false}
        uncheckedIcon={false}
        data-testid={testID}
    />
)

export default RemoteControlledSwitch
